import React, { useState, useRef, useEffect } from 'react';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import NavInf from '../../components/NavInf/NavInf';
import Loader from '../../components/Loader/Loader';
import { secureFetch } from '../../utils/secureFetch';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../config/firebase';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import './InventoryOverview.css';

export default function InventoryOverview() {
    const [expandedProduct, setExpandedProduct] = useState(null);
    const [products, setProducts] = useState([]);
    const contentRefs = useRef({});
    const wrapperRefs = useRef({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchInventory = async () => {
            try {
                const response = await secureFetch('https://api.minymol.com/inventory/overview');

                const data = await response.json();

                setProducts(data.productos || []);
            } catch (error) {
                console.error('Error al cargar inventario:', error);
            } finally {
                setLoading(false);
            }
        };

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                fetchInventory()
            }
        });

        return () => unsubscribe();
        ;
    }, []);

    const toggleExpand = (id) => {
        if (expandedProduct?.id === id) {
            const wrapper = wrapperRefs.current[id];
            const content = contentRefs.current[id];
            if (wrapper && content) {
                wrapper.style.height = `${content.scrollHeight}px`;
                requestAnimationFrame(() => {
                    wrapper.style.height = '0px';
                });
                setTimeout(() => {
                    setExpandedProduct(null);
                }, 400);
            }
        } else {
            const content = contentRefs.current[id];
            if (content) {
                const scrollHeight = content.scrollHeight;
                setExpandedProduct({ id, height: scrollHeight });
                const wrapper = wrapperRefs.current[id];
                if (wrapper) {
                    wrapper.style.height = '0px';
                    requestAnimationFrame(() => {
                        wrapper.style.height = `${scrollHeight}px`;
                    });
                }
            }
        }
    };

    if (loading) {
        return (
            <Loader />
        );
    }

    return (
        <>
            <Header
                minimal={true}
                providerName={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.nombre_empresa}
                providerLogo={JSON.parse(localStorage.getItem('usuario'))?.proveedorInfo?.logo_url}
                menuProvider={true}
                currentPage='view-inventory'
            />
            <div className="inventory-container">
                {products.length === 0 && (
                    <div className="loading-message">
                        <p style={{ textAlign: 'center' }}>No tienes stock configurado</p>
                    </div>)}
                {products.map((product) => (
                    <div key={product.id} className="product-card">
                        <div className="product-header">
                            <img src={product.image || 'https://cdn.minymol.com/default-image.webp'} alt={product.name} />
                            <div className="product-info">
                                <h4>{product.name}</h4>
                                <div className="product-inventory-details">
                                    <p><span>Stock:</span> {product.stock}</p>
                                    <p><span>Valor:</span> {product.stockValue.toLocaleString()}</p>
                                </div>
                            </div>
                        </div>

                        {product.variants.length > 0 && (
                            <>
                                <button
                                    className="variant-toggle"
                                    onClick={() => toggleExpand(product.id)}
                                >
                                    <p>Ver variantes</p>
                                    {expandedProduct?.id === product.id
                                        ? <FontAwesomeIcon icon={faChevronUp} />
                                        : <FontAwesomeIcon icon={faChevronDown} />}
                                </button>

                                <div
                                    className="variants-wrapper"
                                    ref={(el) => (wrapperRefs.current[product.id] = el)}
                                >
                                    <div
                                        className="variants-list"
                                        ref={(el) => (contentRefs.current[product.id] = el)}
                                    >
                                        {product.variants.map((v, i) => (
                                            <div key={i} className="variant-item">
                                                {(() => {
                                                    const { color, size } = v;
                                                    if (!color && !size) {
                                                        return <span>Este producto no tiene variantes</span>;
                                                    }
                                                    if (color && size) {
                                                        return <span>Color: {color} - Talla: {size}</span>;
                                                    }
                                                    if (color) {
                                                        return <span>Color: {color}</span>;
                                                    }
                                                    // si llegó hasta aquí, solo queda size
                                                    return <span>Talla: {size}</span>;
                                                })()}
                                                <span>{v.stock}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}
            </div>
            <NavInf />
            <Footer />
        </>
    );
}
